module.exports = __webpack_public_path__ + "public/img/模具总数.1f7f797e.png";